import React from 'react';
import { pick } from 'ramda';
import FeatureIcons from 'js/components/common/Game/FeatureIcons';
import style from './index.scss';

export const Volatility = ({ code }) => (
    <FeatureIcons
        className={style.volatility}
        classNames={pick(['item', 'image', 'title'], style)}
        code={code}
        showTitle={true}
        types={['volatility']}
    />
);

export const GameStudio = ({ code }) => (
    <FeatureIcons
        className={style.gameStudio}
        classNames={pick(['item'], style)}
        code={code}
        types={['gameStudio']}
    />
);

export const FeatureCategories = ({ code }) => (
    <FeatureIcons
        className={style.featuredIcons}
        classNames={pick(['item', 'image', 'title'], style)}
        code={code}
        size="big"
        showTitle={true}
        types={['goldenChips', 'fsb', 'wilds']}
    />
);
